import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { homeBreadcrumbItem, useBreadcrumbsService } from 'shared/UI/UIKit/Breadcrumbs';
import { getScheduleForWeekUrl } from 'services/navigation';
import { getCurriculums } from 'services/api/educationPlans';
import type { Curriculum } from 'services/api/educationPlans';
import type { ConfigurationSchedulesPageParams } from 'services/navigation';

const getEducationPlanOopBreadcrumbs = (planName: string) => {
  return [
    homeBreadcrumbItem,
    {
      title: 'Расписание на неделю',
      url: getScheduleForWeekUrl(),
    },
    {
      title: planName,
      url: '',
    },
  ];
};

export const useEducationPlanOopPage = () => {
  const { configurationId } = useParams<ConfigurationSchedulesPageParams>();
  const breadcrumbsService = useBreadcrumbsService();
  const [educationPlan, setEducationPlan] = useState<Curriculum | null>(null);

  useEffect(() => {
    if (configurationId) {
      breadcrumbsService.setBreadcrumbsLoading(true);

      getCurriculums()
        .then((res) => {
          const currentPlan = res.find((plan) => plan.id === Number(configurationId));
          if (currentPlan) {
            setEducationPlan(currentPlan);
            breadcrumbsService.setBreadcrumbs(getEducationPlanOopBreadcrumbs(currentPlan.name));
          }
        })
        .finally(() => {
          breadcrumbsService.setBreadcrumbsLoading(false);
        });
    }
  }, [configurationId]);

  return {
    breadcrumbs: breadcrumbsService.breadcrumbs,
    breadcrumbsLoading: breadcrumbsService.breadcrumbsLoading,
    educationPlan,
  };
};
